<div class="d-flex flex-column align-items-center overflow-hidden">
    <adapt-team-meeting-guidance-dashboard-element class="px-3 rounded-2"
                                                   [class.bg-white]="!isAlto"
                                                   [team]="team"
                                                   [embedded]="true"></adapt-team-meeting-guidance-dashboard-element>
</div>
